<template>
    <button
      class="base-btn"
      :class="deleteCellStyle"
      @click="store.P5Instance.deleteSelectedBlob"
    >
      Delete Cell
    </button>
</template>
<script>
import { store } from "../../store";

export default {
  name: "DeleteCellButton",
  data: () => ({ store }),
  computed: {
   deleteCellStyle() {
      return {
        "disabled-btn": !store.selectedBlob,
        "active-red-btn": store.selectedBlob,
      };
    },
  },
};
</script>